import { Sparkles } from "lucide-react";

import { Tag } from "@/design-system/components/Tag/Tag";
import {
  CONVERSION_SOURCE_INFERRED_AD_PLATFORM,
  type ConversionSource,
} from "@/api/insights";

type Props = {
  conversionSource: ConversionSource | "";
};

/**
 * Marks a conversion event Freshpaint inferred rather than the customer
 * configuring it. Renders nothing for user-configured events and for the
 * empty provenance that unconfigured event defs carry, so call sites can pass
 * any event's provenance without guarding first.
 */
export function AutoDetectedTag({ conversionSource }: Props) {
  if (conversionSource !== CONVERSION_SOURCE_INFERRED_AD_PLATFORM) return null;

  return (
    <Tag className="bg-surface-selected text-xs">
      <Sparkles size={12} aria-hidden />
      Auto-selected
    </Tag>
  );
}
